module.exports = __webpack_public_path__ + "img/slide-1.cb431126.jpg";